import React from "react";
import { injectStyle } from "react-toastify/dist/inject-style";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import "./AddNewProduct.css";

if (typeof window !== "undefined") {
  injectStyle();
}

const AddNewProduct = () => {
  const { register, handleSubmit } = useForm();
  // const { user } = useAuth();
  const onSubmit = (data) => {
    console.log(data);
    fetch("https://young-hamlet-12954.herokuapp.com/addProduct", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => console.log("add new result", result));
    toast.dark("New product added successfully");
  };
  return (
    <div className="container text-center mt-2 pt-3 pb-3 m-auto add-new products">
      <h1 className="fw-bold">Add New Product</h1>
      <form className="shipping-form" onSubmit={handleSubmit(onSubmit)}>
        <input
          placeholder="Name"
          {...register("name")}
          className="form-control"
          required
        />
        <br />
        <input
          placeholder="Description"
          {...register("description")}
          className="form-control"
          required
        />
        <br />

        <input
          placeholder="Price"
          type="number"
          className="form-control"
          required
          {...register("price")}
        />
        <br />
        <input
          placeholder="Image Link"
          {...register("img")}
          className="form-control"
          required
        />
        <br />
        <button className="btn btn-custom w-25" type="submit" id="animate.css">
          Add Product
        </button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default AddNewProduct;
